import axios from "axios";

export const fetchDeleteTaskTemplate = async (id: string) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;

  return await axios.delete(`${baseTaskUrl}/TaskTemplate?id=${id}`);
};
